var exports = {
  "i": "x28a7bf27--6d3d10--wrapper",
};

module.exports = exports;
